import Vue from "vue";
import Router from "vue-router";
import SongView from "@/views/SongView.vue";
import SongListView from "@/views/SongListView.vue";
Vue.use(Router);
export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: SongListView
        },
        {
            path: "/index.html",
            component: SongListView
        },
        // {
        //   path: "/about",
        //   name: "about",
        //   // route level code-splitting
        //   // this generates a separate chunk (about.[hash].js) for this route
        //   // which is lazy-loaded when the route is visited.
        //   component: () => import(/* webpackChunkName: "about" */ "./components/SongView.vue"),
        // },
        {
            path: "/song/:songName",
            name: "song",
            component: SongView,
            props: true
        },
    ]
});
//# sourceMappingURL=router.js.map